import { ApiService } from '@stores/ApiService';
import { apiResponse } from '@stores/index';

export type AccountabilityPartnership = {
  participantId: number;
  partnerId: number;
};

export class AccountabilityPartnerStore {
  constructor(private readonly api: ApiService = new ApiService()) {}

  public async adminUpdate(groupId: number, partnerships: AccountabilityPartnership[]) {
    try {
      const response = await this.api.put(`admin/cohort/${groupId}/AccountabilityPartner`, partnerships);
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
